<template>
<div class="country-list" :class="{'is-big': isBig, 'is-point': isShowPoint}" @click.stop="() => {}">
  <div class="country-list-left">
    <div class="country-left-item" v-show="hotcountry.length !== 0" :class="{'tab-hover':countryTab===10}" @mouseenter="toggleCountryTab($event, 10)">
      <img class="icon" src="https://o.666visa.cn/static/ssqpeer/homepage/continent-10.png" />
      <span class="text">热门</span>
    </div>
    <div class="country-left-item"
      :class="{'tab-hover':countryTab===con.continent_id}"
      v-for="(con, index) in continentArr"
      :key="index"
      @mouseenter="toggleCountryTab($event, con.continent_id)"
    >
      <img class="icon" :src="continentMap[con.continent_id].icon" />
      <span class="text">{{continentMap[con.continent_id].cn_name}}</span>
    </div>
    <!-- <div class="country-left-item" v-show="hotcountry.length !== 0" :class="{'tab-hover':countryTab===11}" @mouseenter="toggleCountryTab($event, 11)">
      <img class="icon" src="https://o.666visa.cn/static/ssqpeer/homepage/continent-10.png" />
      <span class="text">其他</span>
    </div> -->
  </div>
  <div class="country-list-right">
    <div class="country-right-item-hot" v-show="countryTab === 10 && hotcountry.length !== 0">
      <div class="country-hot-list">
        <div class="country-hot-item-box" v-for="(hot,index) in hotcountry" :key="index">
          <div
            class="country-hot-item"
            :style="{ background:`url(${hot.background_img}) center/cover no-repeat`}"
            @click="jumpToCountry($event, hot)">
            {{hot.country}}
          </div>
        </div>

      </div>

      <div class="country-all-total">
        <div v-if="showAllCountryBtn" class="s-btn btn-blue is-plain is-round icon-more " :class="{'btn-xs': !isBig}" @click="jumpToCountries">查看全部国家<img src="" /></div>
      </div>
    </div>
    <div class="country-right-item" v-for="(con, outIndex) in continentArr" v-show="countryTab === con.continent_id" :key="outIndex">
      <div class="country-item-box" v-for="(c, inIndex) in con.country" :key="inIndex">
        <div class="country-item" @click="jumpToCountry($event, c)" >{{c.country}}</div>
      </div>
    </div>
    <!-- <div class="country-right-item" v-show="countryTab === 11 && hotcountry.length !== 0">
      <div class="country-item-box" v-for="(c, inIndex) in otherCountry" :key="inIndex">
        <div class="country-item" @click="jumpToCountry($event, c)" >{{c.country}}</div>
      </div>
    </div> -->
  </div>
</div>
</template>
<script>
import sensorsdata from 'sa-sdk-javascript';
import User from '../../libs/user';
import Http from '../../libs/http';
import sensorService from '../../services/sensor-service.js';

export default {
  name: 'nav-country-list',
  props: {
    isBig: { // 是否使用大尺寸
      type: Boolean,
      default: false,
    },
    isShowPoint: { // 是否显示指向的三角形
      type: Boolean,
      default: false,
    },
    showAllCountryBtn: { // 显示所有国家的按钮
      type: Boolean,
      default: true,
    },
    showAllCountry: { // 显示所有国家（包含下架）
      type: Boolean,
      default: false,
    },
    disabledGotoCountryEvent: { // 禁用选择国家跳转的逻辑
      type: Boolean,
      default: false,
    },
    pageFrom: String,
  },
  data() {
    return {
      User,
      continentMap: {
        0: {
          cn_name: '亚洲',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/continent-0.png',
        },
        1: {
          cn_name: '欧洲',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/continent-1.png',
        },
        2: {
          cn_name: '美洲',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/continent-2.png',
        },
        3: {
          cn_name: '大洋洲',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/continent-3.png',
        },
        4: {
          cn_name: '非洲',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/continent-4.png',
        },
        5: {
          cn_name: '其他',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/icon_other.png',
        },
      },
      continentArr: [],
      hotcountry: [],
      countryTab: 0,
    };
  },
  created() {
    let url = '';
    if (!User.isLogin()) {
      url = '/sys/visa_homepage';
    } else {
      url = '/visa_homepage';
    }
    Http.post(url)
      .then((data) => {
        this.hotcountry = data.hot_country.slice(0, this.isBig ? 8 : 9);
        // 若返回热门国家为空，那么默认选中亚洲
        this.countryTab = this.hotcountry.length === 0 ? 0 : 10;
      }).catch((e) => {
        if (e) console.log(e);
      });
    Http.post(this.showAllCountry ? '/sys/visa_continent_all_query' : '/sys/visa_continent_query')
      .then((data) => {
        this.continentArr = data.continent.concat(
          {
            continent_id: 5,
            country: data.special_country.reduce((list, item) => {
              list.push(...item.country);
              return list;
            }, []).filter(item => item),
          },
        );
      }).catch((e) => {
        if (e) console.log(e);
      });
  },
  methods: {
    toggleCountryTab(e, tab) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.countryTab = tab;
    },
    jumpToCountry(e, countryInfo) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$emit('on-hide-self');
      this.$emit('on-click-country', countryInfo);
      if (!this.disabledGotoCountryEvent) {
        let query = {};
        if (this.$route.name === 'country') {
        // 如果在国家页，保留之前的国家筛选的参数
          query = JSON.parse(JSON.stringify(this.$route.query));
        }
        query.from = 'destination_tab';
        // 商详神策埋点page_from字段
        const pageFrom = sensorService.getPageFrom(this.pageFrom || '');
        query = Object.assign(query, pageFrom);
        this.$router.push({ name: 'country', params: { id: countryInfo.visa_country_id }, query });
      }
    },
    jumpToCountries(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$emit('on-hide-self');
      // 商详神策埋点page_from字段
      const query = sensorService.getPageFrom(this.pageFrom || '');
      this.$router.push({ name: 'countries', query });
    },
  },

};
</script>
<style lang="less" scoped>
@import '../../assets/less/variable.less';
// 国家导航有两个size，修改的时候请注意
.country-list{
  background: #fff;
  box-shadow:0px 8px 12px 0px rgba(57,61,70,0.06);
  display: flex;
  font-size: 14px;
  cursor: default;
  border-radius: 2px;
  min-width: 506px;
  &.is-point{
    &::after {
      content: '';
      position: absolute;
      top: -8px;
      left: 50%;
      box-shadow: border-box;
      width: 15px;
      height: 15px;
      background: #fff;
      transform: translateX(-50%) rotate(45deg);
      transform-origin: center center;
      border-top: 1px solid #E9EEF2;
      border-left: 1px solid #E9EEF2;
      border-radius: 2px 0 0 0;
      z-index: 1;
    }
  }

  .country-list-left{
    flex-shrink: 0;
    width: 114px;
    background: #2F333D;
    border-radius: 2px 0 0 2px;
    .country-left-item{
      height: 52px;
      display: flex;
      align-items: center;
      color: #C9CDD1;
      padding-left: 16px;
      .icon{
        width: 28px;
        height: 28px;
        margin-right: 10px;
        opacity: 0.2;
      }
      &.tab-hover{
        color: #fff;
        background: #599FFF;
        .icon{
          opacity: 1;
        }
      }
    }
  }
  .country-list-right{
    flex-shrink: 0;
    width: 392px;
    border: 1px solid #E9EEF2;
    border-radius: 0 2px 2px 0;
    background: #fff;
    .country-right-item-hot{
      padding: 20px 20px 20px 20px;
      .country-hot-list{
        margin-right: -10px;
        margin-left: -10px;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: -12px;
        .country-hot-item-box{
          padding: 0 10px;
          width: 33.33%;
          margin-bottom: 12px;
          .country-hot-item{
            width: 100%;
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-weight: 600;
            border-radius: 3px;
            cursor: pointer;
            transition: all 0.15s;
            &:hover{
              transform: scale(1.1);
            }
          }
        }
      }
      .country-all-total{
        margin-top: 16px;
        text-align: center;
      }
    }
    .country-right-item{
      padding: 20px;
      display: flex;
      flex-wrap: wrap;
      margin-right: -3px;
      margin-left: -3px;
      margin-bottom: -16px;
      .country-item-box{
        width: 25%;
        padding: 0 3px;
        margin-bottom: 16px;
        .country-item{
          cursor: pointer;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #2F333D;
          font-weight: 600;
          line-height: 20px;
          &:hover{
            color: @new-blue;
          }
        }
      }

    }
  }


  &.is-big{
    min-width: 868px;
    .country-list-left{
      width: 160px;
      .country-left-item{
        padding-left: 32px;
        .icon{
          margin-right: 16px;
        }
      }
    }
    .country-list-right{
      background: #fff url('../../assets/imgs/homepage/nav-country-bg.png') no-repeat bottom;
      background-size: 100% auto;
      width: 708px;
      .country-right-item-hot{
        .country-hot-list{
          margin-bottom: -20px;
          .country-hot-item-box{
            width: 25%;
            margin-bottom: 20px;
            .country-hot-item{
              height: 100px;
              font-size: 18px;
            }
          }
        }
        .country-all-total{
          margin-top: 18px;
        }
      }
      .country-right-item{
        margin-right: -10px;
        margin-left: -10px;
        margin-bottom: -24px;
        .country-item-box{
          padding: 0 10px;
          margin-bottom: 24px;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/common/nav-country-list.vue